import _assign from "lodash/assign";
import numeral from 'numeral';
import moment from 'moment';
import uniqid from 'uniqid';
import * as qwest from 'qwest';
/* globals app */

window.app = window.app || {};
var callbacks = {},
  listeners = {};
var global_listeners = {};
app.form_index = 0;
app.images_id = 0;
app.collapse_id = 0;
app.gmap_id = 0;
var initial_load = true;
numeral.locale('en');
moment.locale('fr');
window.numeral = numeral;
window.moment = moment;
window.qwest = qwest;
if (!window.localStorage.getItem('user_id')) {
  window.localStorage.setItem('user_id', uniqid());
}
if (window.localStorage.getItem('widget-date')) {
  if (moment().isAfter(window.localStorage.getItem('widget-date'), 'day')) {
    window.localStorage.setItem('widget-date', moment().format('YYYY-MM-DD'));
  }
}
app.redirectIfNeeded = function (pathname) {
  if (pathname) {
    app.navigateTo(pathname, true);
    return true;
  }
};
app.navigateTo = function (path, auto = false) {
  if (!app.router_history) return;
  if (auto !== true) {
    app.state.form_error = undefined;
  }
  app.resetFunctions();
  app.router_history.push(path);
};
app.resetFunctions = function () {
  if (initial_load === true) {
    initial_load = false;
  } else {
    callbacks = {};
    listeners = {};
  }
  if (typeof ga === 'function') {
    window.ga('send', 'pageview');
  }
};
app.hasListener = function (event) {
  return listeners[event] && listeners[event].length > 0;
};
app.call = function (props) {
  if (props.event) {
    if (!listeners[props.event]) {
      return;
    } else {
      listeners[props.event].filter(function (listener, index) {
        return typeof listener === 'function';
      }).forEach(function (listener, index) {
        listener(props.cb_props);
      });
    }
  } else {
    if (!callbacks[props.name]) {
      console.error('function ' + props.name + ' does not exists');
    } else {
      callbacks[props.name].filter(function (callback, index) {
        return typeof callback === 'function';
      }).forEach(function (callback, index) {
        callback(props.cb_props);
      });
    }
  }
};
app.emit = function ({
  event,
  source,
  data
}) {
  (listeners[event] || []).filter(function (listener, index) {
    return typeof listener === 'function';
  }).forEach(function (listener, index) {
    listener({
      data: data,
      source: source
    });
  });
  (global_listeners[event] || []).filter(function (listener, index) {
    return typeof listener === 'function';
  }).forEach(function (listener, index) {
    listener({
      data: data,
      source: source
    });
  });
};
app.push = function ({
  event,
  cb,
  global
}) {
  if (event && global === true) {
    global_listeners[event] = global_listeners[event] || [];
    global_listeners[event].push(cb);
  } else if (event) {
    if (event === 'documentScroll' && !app.hasListener(event)) {
      handleDocumentScrollListener('append');
    }
    listeners[event] = listeners[event] || [];
    listeners[event].push(cb);
  } else {
    callbacks[name] = callbacks[name] || [];
    callbacks[name].push(cb);
  }
};
function handleDocumentScrollListener(option) {
  var scroll_area = document;
  if (!scroll_area) return console.error('no scroll area');
  var ticking = false;
  if (option === 'append') {
    scroll_area.addEventListener('scroll', listener);
  } else if (option === 'remove') {
    scroll_area.removeEventListener('scroll', listener);
  }
  function listener(e) {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        ticking = false;
        app.call({
          event: 'documentScroll'
        });
      });
    }
    ticking = true;
  }
}
app.delete = function ({
  event,
  cb,
  name
}) {
  if (event && listeners[event]) {
    listeners[event] = listeners[event].filter(function (listener, index) {
      return cb !== listener;
    });
  } else if (callbacks[name]) {
    callbacks[name] = callbacks[name].filter(function (callback, index) {
      return cb !== callback;
    });
  }
};
app.state = app.state || {};
app.initState = function () {
  app.History = window.History;
  app.state = app.state || {};
  global_listeners = {};
  _assign(app.state, {
    search_data: {},
    recaptchas: {},
    external_scripts: {}
  });
  let default_session = window.__default_session;
  if (default_session) {
    try {
      app.state.session = JSON.parse(default_session);
    } catch (e) {
      app.state.session = undefined;
      console.error('error parsing session', e);
    }
  }
  if (!app.state.session) app.state.session = {
    fetched: false
  };
  if (getIEVersion() > 0) {
    app.state.ie = getIEVersion();
  }
  function getIEVersion() {
    var sAgent = window.navigator.userAgent;
    var Idx = sAgent.indexOf("MSIE");

    // If IE, return version number.
    if (Idx > 0) {
      return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
    }

    // If IE 11 then look for Updated user agent string.
    else if (navigator.userAgent.match(/Trident\/7\./)) {
      return 11;
    } else {
      return 0;
    }
  }
};
app.initState();
window.addEventListener('resize', function (e) {
  app.emit({
    event: 'window.resize',
    source: 'GlobalFunctions'
  });
});
app.initGoogleMap = () => {};
